export interface EnergyAlertSettingsResponse {
	isEnabled: boolean;
	isReminderEnabled: boolean;
	unitThreshold: number | null;
	isAutoRechargeEnabled: boolean;
	autoRechargeAmount: number | null;
	savedCardId: string | null;
}

export const emptyEnergyAlertSettings: EnergyAlertSettingsResponse = {
	isEnabled: false,
	isReminderEnabled: false,
	unitThreshold: null,
	isAutoRechargeEnabled: false,
	autoRechargeAmount: null,
	savedCardId: null,
};
